/* eslint-disable react-hooks/exhaustive-deps */
import { Checkbox } from '@mui/material';
import { UPDATE_HOMESALE_INFO_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { getHomesaleInfo, postHomesaleInfo, updateHomesaleInfo } from 'modules/authorizations/store/actions/homesale.actions';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useEffect, useState } from 'react';

const ProgramInfoCard = props => {
  const [isLoading, setIsLoading] = useState(false);
  const [isGbo, setIsGbo] = useState(false);
  const { isReadOnly, saleTypesEnum, isOnHold } = props;
  const homesaleInfo = props.homesale ? props.homesale.homesaleInfo : null;

  const [homeSaleInfoState, setHomeSaleInfoState] = useState({ ...homesaleInfo });

  const typeOptions =
    saleTypesEnum && saleTypesEnum.length > 0
      ? saleTypesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const tabs = [{ header: 'Homesale Program Info', order: 1, iconPath: ['fas', 'file-invoice'] }];

  const dateDiff = (endDate, startDate) => {
    const diffInMs = endDate - startDate;
    return Math.round(diffInMs / (1000 * 60 * 60 * 24));
  };

  const getListingLengthReq = (goalForListing, listingEndDate) => {
    if (!goalForListing || !listingEndDate) return '';

    const startDate = new Date(goalForListing);
    const endDate = new Date(listingEndDate);
    if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return '';

    const startUtc = Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
    const endUtc = Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
    const diffInMs = endUtc - startUtc;
    const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24)) + 1;
    return `${diffInDays} days`;
  };

  useEffect(() => {
    setIsGbo(homeSaleInfoState && homeSaleInfoState.saleTypeId && homeSaleInfoState.saleTypeId === '4c4590e0-b974-48a0-a0dd-7e01d25c412a');
  }, [homeSaleInfoState.saleTypeId]);

  const summaries = [
    {
      header: 'Sale Type',
      accessorKey: 'saleTypeId',
      type: 'dropdown-v2',
      required: false,
      value: homesaleInfo ? homesaleInfo.saleTypeId : null,
      options: typeOptions,
      tab: 1
    },
    {
      header: 'Initiation Date',
      accessorKey: 'initiationDate',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.initiationDate : '',
      tab: 1,
      disabled: true
    },
    {
      header: 'Marketing Period',
      accessorKey: 'marketingPeriod',
      type: 'number',
      required: false,
      value: homesaleInfo ? homesaleInfo.marketingPeriod : '',
      tab: 1,
      hideInModal: isGbo ? false : true,
      hideInTable: isGbo ? false : true
    },
    {
      header: 'Marketing Start',
      accessorKey: 'marketingPeriodBegin',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.marketingPeriodBegin : '',
      tab: 1,
      hideInModal: isGbo ? false : true,
      hideInTable: isGbo ? false : true
    },
    {
      header: 'Marketing End',
      accessorKey: 'marketingPeriodEnd',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.marketingPeriodEnd : '',
      tab: 1,
      hideInModal: isGbo ? false : true,
      hideInTable: isGbo ? false : true
    },
    {
      header: 'On Hold',
      accessorKey: 'onHold',
      type: 'checkbox',
      required: false,
      value: isOnHold,
      tab: 1,
      hideInModal: true,
      Cell: ({ cell }) => <Checkbox name="onHold" label="Active" checked={isOnHold} disabled={true} />
    },
    {
      header: 'On Hold Start',
      accessorKey: 'onHoldStartDate',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.onHoldStartDate : '',
      tab: 1,
      disabled: true,
      hideInModal: true
    },
    {
      header: 'On Hold End',
      accessorKey: 'onHoldEndDate',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.onHoldEndDate : '',
      tab: 1,
      disabled: true,
      hideInModal: true
    },
    {
      header: 'Cancelled',
      accessorKey: 'cancelled',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.cancelled : '',
      tab: 1
    },
    {
      header: 'Days Held',
      accessorKey: 'daysHeld',
      type: 'number',
      required: false,
      value:
        (homesaleInfo && homesaleInfo.onHoldStartDate && homesaleInfo.onHoldEndDate
          ? Math.max(0, dateDiff(new Date(homesaleInfo.onHoldEndDate), new Date(homesaleInfo.onHoldStartDate)))
          : '').toString(),
      hideInModal: true,
      tab: 1
    },
    {
      header: 'Days on Market',
      accessorKey: 'daysOnMarket',
      type: 'number',
      required: false,
      value:
        (homesaleInfo && homesaleInfo.marketingPeriodEnd && homesaleInfo.marketingPeriodBegin
          ? Math.max(0, dateDiff(new Date(homesaleInfo.marketingPeriodEnd), new Date(homesaleInfo.marketingPeriodBegin)))
          : '').toString(),
      hideInModal: true,
      tab: 1
    },
    { dividerLine: true, tab: 1 },
    {
      header: 'Goal for Listing Date',
      accessorKey: 'goalForListing',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.goalForListing : '',
      tab: 1
    },
    {
      header: 'Listing Length Req',
      accessorKey: 'listingLengthReq',
      type: 'text',
      required: false,
      value: homesaleInfo ? getListingLengthReq(homesaleInfo.goalForListing, homesaleInfo.listingEndDate) : '',
      tab: 1,
      hideInModal: true
    },
    {
      header: 'Estimated Listing End Date',
      accessorKey: 'listingEndDate',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.listingEndDate : '',
      tab: 1
    },
    {
      header: 'Inspection Start Date',
      accessorKey: 'inspectionStartDate',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.inspectionStartDate : '',
      tab: 1
    },
    {
      header: 'Appraisal Start Date',
      accessorKey: 'appraisalStartDate',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.appraisalStartDate : '',
      tab: 1
    },
    {
      header: 'Approx Acquisition Date',
      accessorKey: 'approxAcquisitionDate',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.approxAcquisitionDate : '',
      tab: 1
    }
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newValues = { ...homesaleInfo };

    newValues.saleTypeId = values.saleTypeId;
    newValues.marketingPeriod = values.marketingPeriod;
    newValues.marketingPeriodBegin = values.marketingPeriodBegin === '' ? null : values.marketingPeriodBegin;
    newValues.marketingPeriodEnd = values.marketingPeriodEnd === '' ? null : values.marketingPeriodEnd;
    newValues.cancelled = values.cancelled === '' ? null : values.cancelled;
    newValues.goalForListing = values.goalForListing === '' ? null : values.goalForListing;
    newValues.listingEndDate = values.listingEndDate === '' ? null : values.listingEndDate;
    newValues.inspectionStartDate = values.inspectionStartDate === '' ? null : values.inspectionStartDate;
    newValues.appraisalStartDate = values.appraisalStartDate === '' ? null : values.appraisalStartDate;
    newValues.approxAcquisitionDate = values.approxAcquisitionDate === '' ? null : values.approxAcquisitionDate;

    const resp = await props.updateHomesaleInfo(newValues);
    if (resp.type === UPDATE_HOMESALE_INFO_FAILURE) {
      props.showToast('Failed to update homesale info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      await props.getHomesaleInfo(homesaleInfo.authorizationFileId);
      setIsLoading(false);
      return true;
    }
    
  };

  return (
    <EditableCard
      tabs={tabs}
      summaries={summaries}
      numColumns={5}
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={isReadOnly}
      setDataState={setHomeSaleInfoState}
      dataState={homeSaleInfoState}
      onCancelProp={() => setHomeSaleInfoState({ ...homesaleInfo })}
    />
  );
};

const mapStateToProps = state => {
  const { saleTypes } = state.enumerations.allEnums;
  return {
    saleTypesEnum: saleTypes
  };
};

export default compose(
  connect(mapStateToProps, {
    updateHomesaleInfo,
    postHomesaleInfo,
    showToast,
    getHomesaleInfo
  })
)(ProgramInfoCard);
